'use strict';


var ng_module_dependencies = [];
// Dynamically defined deps
if (context.SENTRY_DSN) {
	ng_module_dependencies.push('ngSentry');
}

angular.module('Syrinscape', ng_module_dependencies.concat([
	'ngRoute',
	'ngSanitize',
	'ui.sortable',
	'angular-loading-bar',
	'ui.select',
	'Syrinscape.filters',
	'Syrinscape.services',
	'Syrinscape.directives',
	'Syrinscape.controllers'
]))
.config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/', {
		templateUrl: context.urls.STATIC_URL + 'master/frontend/html_partials/syrinscape.html?gc=' + context.GIT_COMMIT,
		controller: 'Editor',
		// Prevent the app from reloading every time the app state effects the url
		reloadOnSearch: false,
	});
}])
.config(['$httpProvider', function($httpProvider) {
	$httpProvider.defaults.headers.common.Authorization = 'Token ' + context.API_TOKEN;
	$httpProvider.defaults.headers.options = {
		'Authorization': 'Token ' + context.API_TOKEN
	}
	$httpProvider.defaults.headers.patch = {
		'Content-Type': 'application/json;charset=utf-8',
		'X-CSRFToken': context.CSRF_TOKEN,
	};
	$httpProvider.interceptors.push(function($q, response_errors) {
		return {
			responseError: function(res) {
				response_errors.handle_$http_response(res);
				return $q.reject(res);
			}
		};
	});
}])
.config(['$sceDelegateProvider',function($sceDelegateProvider) {  
	$sceDelegateProvider.resourceUrlWhitelist([
		'self',
		`${context.SITE_PROTOCOL}://${context.SITE_DOMAIN_AND_PORT}/**`,
	])
}])
;



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/app.js